<template>
  <div>
    <a-row>
      <a-col :lg="24" :xl="17" :xxl="18">
        <div class="show_box">
          <!-- :url="
              classesData[selectId].belong == 1
                ? 'http://192.168.0.108:3000/baseClass/' +
                  classesData[selectId].url.replace('\\', '/')
                : classesData[selectId].url
            " -->
          <FilesShow
            v-if="classesData.length > 0"
            :fileId="classesData[selectId].id"
            :type="classesData[selectId].type"
            :url="classesData[selectId].url.replace('\\', '/')"
          ></FilesShow>
        </div>
        <div class="show_text_box">
          <div class="title_box">
            <div class="title">{{ name }}</div>
            <div class="label">{{ classesData.length }}个课件</div>
          </div>
          <div class="label_box">
            {{ classesData.length > 0 ? classesData[selectId].name : "" }}
          </div>
        </div>
      </a-col>
      <a-col :lg="24" :xl="7" :xxl="6">
        <div class="courseware_list">
          <div class="courseware_list_title">
            <div class="title_box"></div>
            <div class="tiele">课件列表</div>
          </div>
          <div class="courseware_list_box">
            <div
              :class="
                index == selectId ? 'courseware courseware_on' : 'courseware'
              "
              v-for="(item, index) in classesData"
              :key="index"
              @click="playStudy(index)"
            >
              <div class="courseware_name">
                {{ index + 1 < 10 ? "0" + (index + 1) : index + 1 }}、{{
                  item.name
                }}
              </div>
              <div class="courseware_time" v-if="item.duration != 0">
                {{ formatSeconds(item.duration) }}
              </div>
              <div class="courseware_time" v-else>
                {{ item.type }}
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <div style="margin-top: 20px; float: right">
      <a-button
        @click="gameBefor = true"
        style="background: #0073ff; border: none; color: #ffffff"
      >
        完成培训，去考试
      </a-button>
    </div>
    <div class="gameBefor" v-if="gameBefor">
      <div class="gameBeforCon">
        <div class="gameBeforContent">
          <div class="gameBeforContentTitle">考试说明</div>
          <div>
            <table border="1" cellspacing="0">
              <tr>
                <td align="center" class="tth" colspan="1">题型</td>
                <td align="center" class="tth" colspan="1">题数</td>
                <td align="center" class="tth" colspan="1">分数</td>
              </tr>
              <tr>
                <td align="center" class="tth" colspan="1">单选题</td>
                <td align="center" colspan="1">
                  {{ topicsData.filter((v) => v.type == 1).length }}
                </td>
                <td align="center" colspan="1">
                  {{ types(1) }}
                </td>
              </tr>
              <tr>
                <td align="center" class="tth" colspan="1">多选题</td>
                <td align="center" colspan="1">
                  {{ topicsData.filter((v) => v.type == 3).length }}
                </td>
                <td align="center" colspan="1">
                  {{ types(3) }}
                </td>
              </tr>
              <tr>
                <td align="center" class="tth" colspan="1">判断题</td>
                <td align="center" colspan="1">
                  {{ topicsData.filter((v) => v.type == 2).length }}
                </td>
                <td align="center" colspan="1">
                  {{ types(2) }}
                </td>
              </tr>
              <tr>
                <td align="center" class="tth" colspan="1">总数</td>
                <td align="center" colspan="1">{{ topicsData.length }}</td>
                <td align="center" colspan="1">100</td>
              </tr>
            </table>
            <div class="gameBeforContentMsg">
              总分为{{ bad }}分及以上合格，{{ bad }}分以下不合格。
            </div>
            <div style="text-align: right">
              <a-button size="large" type="primary" @click="goExamination"
                >开始考试</a-button
              >
            </div>
          </div>
        </div>
        <div class="jianceClose" @click="gameBefor = false">
          <a-icon type="close" size="20" style="color: #a1a8b0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trainProgramInfo } from "@/request/classes";
import { formatSeconds } from "@/utils/util";
import FilesShow from "@/components/FilesShow/index.vue";
export default {
  components: {
    FilesShow,
  },
  props: {
    //培训方案名称
    name: {
      type: String,
      default: "",
    },
    //课程列表
    classesData: {
      type: Array,
      default() {
        return [];
      },
    },
    bad: {
      type: [String, Number],
      default: 0,
    },
    //题目数据
    topicsData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    "classesData.length": {
      handler(newV, oldV) {
        console.log(newV, oldV);
        if (newV > 0) {
          this.emitClass();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$emit("startStudy");
  },
  data() {
    return {
      selectId: 0,
      gameBefor: false,
    };
  },
  methods: {
    formatSeconds,
    emitClass() {
      this.$emit("addStudyClass", this.classesData[this.selectId]);
    },
    playStudy(id) {
      this.$nextTick(() => {
        this.selectId = id;
        this.emitClass();
      });
      // this.$forceUpdate();
    },
    goExamination() {
      this.$emit("goExamination");
    },
    types(type) {
      let d = 0;
      const l = this.topicsData.filter((v) => v.type == type);
      console.log(l);
      l.forEach((v) => (d += v.fenzhi));
      return d;
    },
  },
};
</script>

<style lang="scss" scoped>
.show_box {
  width: 100%;
  height: 620px;
  background: #fff;
}

.show_text_box {
  width: 100%;
  height: 90px;
  background: #f5f6fa;
  box-sizing: border-box;
  padding: 20px;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 20px;
      font-weight: 400;
      color: #011733;
    }

    .label {
      font-size: 14px;
      font-weight: 400;
      color: #0073ff;
    }
  }

  .label_box {
    font-size: 14px;
    font-weight: 400;
    color: #9ba2ab;
  }
}

.courseware_list {
  width: 100%;
  height: 710px;
  background: #fafbff;
  border: 1px solid #f5f6fa;

  .courseware_list_title {
    box-sizing: border-box;
    padding: 15px 20px;
    border-bottom: 1px solid #f5f6fa;
    display: flex;
    align-items: center;

    .title_box {
      width: 6px;
      height: 30px;
      background: #0073ff;
    }

    .tiele {
      margin-left: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #011733;
    }
  }

  .courseware_list_box {
    box-sizing: border-box;
    padding: 20px 0 20px 20px;
    height: 647px;
    overflow-y: auto;

    .courseware {
      display: flex;
      justify-content: space-between;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 30px 10px 26px;
      font-size: 14px;
      font-weight: 400;
      color: #9ba2ab;
      cursor: pointer;
    }

    .courseware_on {
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
  }
}
.courseware_name {
  max-width: 70%;
  font-size: 14px;
  color: #9ba2ab;
}
.courseware_time {
  font-size: 12px;
  color: #9ba2ab;
}
.gameBefor {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 99999;
  .gameBeforCon {
    display: flex;
    align-items: start;
    .gameBeforContent {
      width: 370px;
      background: #ffffff;
      border-radius: 10px;
      padding: 30px 30px 20px 30px;
      box-sizing: border-box;
    }
    .jianceClose {
      width: 30px;
      height: 30px;
      background: #f5f6fa;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 20px;
    }
  }
}

table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
table,
table tr th,
table tr td {
  border: 1px solid #f5f6fa;
}
table tr td {
  height: 45px;
  width: 33%;
}
.gameBeforContentTitle {
  font-size: 18px;
  font-weight: 400;
  color: #011733;
  margin-bottom: 30px;
  text-align: center;
}
.gameBeforContentMsg {
  font-size: 14px;
  font-weight: 400;
  color: #ea1313;
  margin-top: 20px;
  margin-bottom: 30px;
}
.tth {
  background: #fafbff;
}
.ttd {
  background: #fff;
}
</style>